import { DefaultPageHeader } from 'layouts';
import { usePermissions } from 'permissions';
import { AdminConsoleButton } from 'features/admin-dashboard';
import { GivingScopeEnum } from '../types';

type P = {
  navigateToGiveNow: () => Promise<void>;
  navigateToGivingBrowse: () => Promise<void>;
  scope: GivingScopeEnum;
};

const items = [
  {
    label: 'Give now',
    value: GivingScopeEnum.NOW,
  },
  {
    label: 'Browse',
    value: GivingScopeEnum.BROWSE,
  },
];

const Navigation = ({ navigateToGiveNow, navigateToGivingBrowse, scope }: P) => {
  const { canViewAdminDashboardGivings } = usePermissions();

  return (
    <DefaultPageHeader<GivingScopeEnum>
      extra={canViewAdminDashboardGivings({}) ? <AdminConsoleButton entityType="giving" /> : null}
      radioPills={{
        items,
        async onChange(event) {
          switch (event.target.value) {
            case GivingScopeEnum.BROWSE:
              await navigateToGivingBrowse();
              break;
            case GivingScopeEnum.NOW:
              await navigateToGiveNow();
              break;
            case undefined:
              console.warn('Unknown menu key', event.target.value);
          }
        },

        value: scope,
      }}
      title="Giving"
    />
  );
};

export default Navigation;
